// imports react
import React, { useEffect, useRef, useState } from "react";

//imports libraries
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Menu } from "../../components/Menu";
import axios from "axios";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import styles from "../../styles/dashboard.module.css";
import { urlAPI_Current } from "../../config";
import { verifyAuthToken } from "../../verifyAuthToken";

export function Dashboard() {
  const [countUsers, setCountUsers] = useState(0);
  const [countUsersAnswered, setCountUsersAnswered] = useState(0);
  const [countUsersNotAnswered, setCountUsersNotAnswered] = useState(0);
  const [countMessagesToday, setCountMessagesToday] = useState(0);
  const [dataMessages, setDataMessages] = useState([]);
  const [lastestTransactions, setLastestTransactions] = useState([]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(0);
  const [countPayment, setCountPayment] = useState(0);
  const [refillsOpenAI, setReffilsOpenAI] = useState([]);
  const [userAccess, setUserAccess] = useState([]);
  const [totalSpentOpenAI, setTotalSpentOpenAI] = useState(0);
  const menuRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const navigateTo = useNavigate();

  const [darkMode, setDarkMode] = useState(
    () => window.localStorage.getItem("darkMode") === "true"
  );

  async function getCountUsers() {
    try {
      const responseCountUsers = await axios.post(
        `${urlAPI_Current}/getCountUsers`,
        {}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
        }
      );
      if (responseCountUsers.data.success == true) {
        const countUsers = responseCountUsers.data.countUsers;
        setCountUsers(countUsers);
      }

      const responseCountUsersAnswered = await axios.post(
        `${urlAPI_Current}/getCountUsersAnswered`,
        {}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
        }
      );
      if (responseCountUsersAnswered.data.success == true) {
        const countUsersAmswered = responseCountUsersAnswered.data.countUsers;
        setCountUsersAnswered(countUsersAmswered);
      }

      const responseCountUsersNotAnswered = await axios.post(
        `${urlAPI_Current}/getCountUsersNotAnswered`,
        {}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
        }
      );
      if (responseCountUsersNotAnswered.data.success == true) {
        const getCountUsersNotAnswered =
          responseCountUsersNotAnswered.data.countUsers;
        setCountUsersNotAnswered(getCountUsersNotAnswered);
      }
    } catch (error) {
      console.log("Erro ao buscar quantidade de usuários");
    }
  }

  async function getCountMessagesEvokchat() {
    try {
      const response = await axios.post(
        `${urlAPI_Current}/getCountMessagesEvokchat`,
        {}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
        }
      );
      if (response.data.success) {
        const data = response.data.dailyCounts.map((item) => ({
          dia: item.dia,
          quantidade: item.quantidade,
        }));

        const orderedData = [
          data.find((item) => item.dia === "Hoje"),
          data.find((item) => item.dia === "Ontem"),
          data.find((item) => item.dia === "Anteontem"),
        ];

        const today = data.find((item) => item.dia === "Hoje");

        if (today) {
          setCountMessagesToday(today.quantidade);
        } else {
          setCountMessagesToday(0);
        }

        setDataMessages(orderedData.reverse());
      }
    } catch (error) {
      console.error("Erro ao buscar quantidade de mensagens", error);
    }
  }

  async function getLastestTransactions(filterDate) {
    try {
      setSelectedDate(filterDate);
      const responseLastestTransactions = await axios.post(
        `${urlAPI_Current}/getLastestTransactions`,
        {}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
        }
      );
      if (responseLastestTransactions.data.success == true) {
        const lastestTransactions = responseLastestTransactions.data.lastestTransactions;
        setLastestTransactions(lastestTransactions);
      }
    } catch (error) {
      console.log("Erro ao buscar ultimos pagamentos");
    }
  }

  async function getCountSubscription() {
    try {
      const responseCountSubscription = await axios.post(
        `${urlAPI_Current}/getCountSubscription`,
        {}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
        }
      );
      if (responseCountSubscription.data.success == true) {
        const countPayment = responseCountSubscription.data.countPayments;
        setCountPayment(countPayment);
      }
    } catch (error) {
      console.log("Erro ao buscar quantidade de usuários");
    }
  }

  async function getReffilsOpenAI() {
    try {
      const responseReffilsOpenAI = await axios.post(
        `${urlAPI_Current}/getReffilsOpenAI`,
        {}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
        }
      );
      if (responseReffilsOpenAI.data.success == true) {
        const reffilsOpenAI = responseReffilsOpenAI.data.reffils;
        const totalSpentOpenAI = responseReffilsOpenAI.data.totalSpent;
        setReffilsOpenAI(reffilsOpenAI);
        setTotalSpentOpenAI(totalSpentOpenAI);
      }
    } catch (error) {
      console.log("Erro ao buscar quantidade de usuários");
    }
  }

  async function getUserAccess() {
    try {
      const responseUserAccess = await axios.post(
        `${urlAPI_Current}/getUserAccess`,
        {
          filterDate: 7,
        }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
        }
      );
      if (responseUserAccess.data.success == true) {
        const userAccesss = responseUserAccess.data.access;
        setUserAccess(userAccesss);
      }
    } catch (error) {
      console.log("Erro ao buscar quantidade de usuários");
    }
  }

  const handleClick = () => {
    setShowDatePicker(!showDatePicker);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0"); // Dia
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Mês (0-indexed)
    const year = date.getFullYear(); // Ano
    const hours = String(date.getHours()).padStart(2, "0"); // Horas
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Minutos

    if(hours == 0 && minutes == 0){
      return `${day}/${month}/${year}`;
    }

    return `${day}/${month}/${year} às ${hours}:${minutes}h`;
  }

  const formattedData = refillsOpenAI.map(item => ({
    dia: new Date(item.dataRecarga).toLocaleDateString('pt-BR', { month: 'short', year: 'numeric' }),
    quantidade: item.valor
  }));

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const totalValue = lastestTransactions.reduce((sum, transaction) => sum + transaction.valor, 0);

  useEffect(() => {
    const fetchData = async () => {
        try {

            const responseEmail = await axios.post(
                `${urlAPI_Current}/getProfile`, {} , {
                  headers: {
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                  }
               }
            );

            if (responseEmail.data.user.codTipoUsuario == 2) {
              getCountUsers();
              getCountMessagesEvokchat();
              getLastestTransactions(7);
              getCountSubscription();
              getReffilsOpenAI();
              getUserAccess();
            } else {
                toast.error("Você não tem acesso a essa página");
                navigateTo("/login");
            }
        } catch (error) {
            console.error("Erro ao buscar perfil:", error);
        }
    };

    fetchData();

    window.localStorage.setItem('darkMode', darkMode);
    document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [darkMode]);

  const backgroundColor = darkMode ? "#333" : "#fff";
  const strokeColor = darkMode ? "#fff" : "#333";
  const gridColor = darkMode ? "#555" : "#e0e0e0";
  const tooltipBackgroundColor = darkMode ? "#333" : "#f5f5f5";
  const tooltipBorderColor = darkMode ? "#444" : "#ccc";
  const lineColor = darkMode ? "#8884d8" : "#8884d8";

  useEffect(() => {
    verifyAuthToken(navigateTo);
  }, []);

  return (
    <div>
      <Menu
        darkMode={darkMode}
        adminUser={true}
        adminPageActually="dashboard"
      />

      <div className={styles.containerDashboard}>
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
          data-bs-theme={darkMode ? "dark" : "light"}
        >
          <div id="kt_content_container" className="container-xxl">
            <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
              <div className="col-xl-3">
                <div
                  className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-xl-100"
                  style={{
                    backgroundColor: "#7239EA",
                    backgroundImage:
                      "url('assets/media/svg/shapes/wave-bg-purple.svg')",
                  }}
                >
                  <div className="card-header pt-5 mb-3">
                    <div
                      className="d-flex flex-center rounded-circle h-80px w-80px"
                      style={{
                        border: "1px dashed rgba(255, 255, 255, 0.4)",
                        backgroundColor: "#7239EA",
                      }}
                    >
                      <i className="ki-outline ki-profile-circle text-white fs-2qx lh-0"></i>
                    </div>
                  </div>

                  <div className="card-body d-flex align-items-end mb-3">
                    <div className="d-flex align-items-center">
                      <span className="fs-4hx text-white fw-bold me-6">
                        {countUsers}
                      </span>
                      <div className="fw-bold fs-6 text-white">
                        <span className="d-block">Total de</span>
                        <span>Clientes</span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="card-footer"
                    style={{
                      borderTop: "1px solid rgba(255, 255, 255, 0.3)",
                      background: "rgba(0, 0, 0, 0.15)",
                    }}
                  >
                    <div className="fw-bold text-white py-2">
                      <span className="fs-1 d-block">{countUsersAnswered}</span>
                      <span className="opacity-50">
                        Responderam o Questionário
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3">
                <div
                  className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-xl-100"
                  style={{
                    backgroundColor: "#F1416C",
                    backgroundImage:
                      "url('assets/media/svg/shapes/wave-bg-red.svg')",
                  }}
                >
                  <div className="card-header pt-5 mb-3">
                    <div
                      className="d-flex flex-center rounded-circle h-80px w-80px"
                      style={{
                        border: "1px dashed rgba(255, 255, 255, 0.4)",
                        backgroundColor: "#F1416C",
                      }}
                    >
                      <i className="ki-outline ki-black-down text-white fs-2qx lh-0"></i>
                    </div>
                  </div>

                  <div className="card-body d-flex align-items-end mb-3">
                    <div className="d-flex align-items-center">
                      <span className="fs-4hx text-white fw-bold me-6">
                        {countUsersNotAnswered}
                      </span>
                      <div className="fw-bold fs-6 text-white">
                        <span className="d-block">Total de </span>
                        <span>Clientes Inativos</span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="card-footer"
                    style={{
                      borderTop: "1px solid rgba(255, 255, 255, 0.3)",
                      background: "rgba(0, 0, 0, 0.15)",
                    }}
                  >
                    <div className="fw-bold text-white py-2">
                      <span className="fs-1 d-block">
                        Não responderam o questionário
                      </span>
                      <span className="opacity-50">
                        Não utilizam o evokchat
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-6">
                <div className="card card-flush overflow-hidden h-lg-100">
                  <div className="card-header pt-5">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-gray-900">
                        Mensagens com o EvokChat
                      </span>
                      <span className="text-gray-500 mt-1 fw-semibold fs-6">
                        {countMessagesToday} Mensagens hoje
                      </span>
                    </h3>
                    <div className="card-toolbar">
                      <div
                        data-kt-daterangepicker="true"
                        data-kt-daterangepicker-opens="left"
                        data-kt-daterangepicker-range="today"
                        className="btn btn-sm btn-light d-flex align-items-center px-4"
                      >
                        <div className="text-gray-600 fw-bold">
                          Gráfico de informações
                        </div>
                        <i className="ki-outline ki-calendar-8 text-gray-500 lh-0 fs-2 ms-2 me-0"></i>
                      </div>
                    </div>
                  </div>
                  <div className="card-body d-flex align-items-end p-0">
                    <div
                      id="kt_charts_widget_36"
                      className="min-h-auto w-100 ps-4 pe-6"
                      style={{ height: "300px" }}
                    >
                      <div style={{ padding: "20px", borderRadius: "8px" }}>
                        <ResponsiveContainer width="100%" height={300}>
                          <LineChart
                            data={dataMessages}
                            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                          >
                            <CartesianGrid
                              stroke={gridColor}
                              strokeDasharray="none"
                            />
                            <XAxis dataKey="dia" stroke={strokeColor} />
                            <YAxis
                              stroke={strokeColor}
                              padding={{ top: 20, bottom: 20 }}
                              allowDecimals={false}
                            />
                            <Tooltip
                              contentStyle={{
                                backgroundColor: tooltipBackgroundColor,
                                border: `1px solid ${tooltipBorderColor}`,
                              }}
                            />
                            <Legend />
                            <Line
                              type="monotone"
                              dataKey="quantidade"
                              stroke={lineColor}
                              activeDot={{ r: 8 }}
                            />
                          </LineChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4">
                <div className="card card-flush h-xl-100">
                  <div className="card-header pt-7">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-gray-800">
                        Quantidade de pagamentos
                      </span>
                      <br />
                      <span className="text-gray-500 mt-1 fw-semibold fs-6">
                        {countPayment}
                      </span>
                    </h3>

                    <div className="card-toolbar"></div>
                  </div>
                </div>
              </div>
              <div className="col-xl-8">
                <div className="card card-flush h-lg-100">
                  <div className="card-header pt-7">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-gray-800">
                        Todos os Pagamentos
                      </span>
                      <br />
                      <strong>Total de Ganho:</strong> 
                      <span className="badge badge-light-success fs-base">
                      <i className="ki-outline ki-arrow-up fs-5 text-success ms-n1"></i>
                        R$ {(totalValue / 100).toFixed(2)}
                      </span>
                    </h3>
                  </div>

                  <div className="card-body pt-6">
                    <div className="table-responsive">
                      <table className="table table-row-dashed align-middle gs-0 gy-3 my-0">
                        <thead>
                          <tr className="fs-7 fw-bold text-gray-500 border-bottom-0">
                            <th className="p-0 pb-3 min-w-175px text-start">
                              CLIENTE
                            </th>
                            <th className="p-0 pb-3 min-w-100px text-end">
                              PLANO
                            </th>
                            <th className="p-0 pb-3 min-w-100px text-end">
                              VALOR
                            </th>
                            <th className="p-0 pb-3 min-w-100px text-end">
                              DATA
                            </th>
                            <th className="p-0 pb-3 min-w-150px text-end pe-12">
                              DESCONTO
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                              {lastestTransactions.map((transaction, index) => (
                                      <tr key={index}>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <div className="symbol symbol-50px me-3">
                                            {transaction && transaction.foto ? (
                                  <img
                                      src={`https://evoktm.com.br/evokchat/fotos_usuarios/${transaction.foto}`}
                                      alt="Foto do usuário"
                                  />
                              ) : (
                                  <div 
                                      className="symbol-label fs-3 bg-primary text-white" 
                                  >
                                      {transaction && transaction.nome ? transaction.nome.slice(0, 2).toUpperCase() : 'N/A'}
                                  </div>
                              )}
                                  </div>
                                  <div className="d-flex justify-content-start flex-column">
                                    <p
                                      href="apps/projects/users.html"
                                      className="text-gray-800 fw-bold text-hover-primary mb-1 fs-6"
                                    >
                                      {transaction.nome}
                                    </p>
                                    <span className="text-gray-500 fw-semibold d-block fs-7">
                                      {transaction.email}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td className="text-end pe-0">
                                <span className="text-gray-600 fw-bold fs-6">
                                  {transaction.plano === 1 ? "EvokPersona com Devolutiva" : "EvokPersona sem Devolutiva"}
                                </span>
                              </td>
                              <td className="text-end pe-0">
                                <span className="badge badge-light-success fs-base">
                                  <div>
                                    <i className="ki-outline ki-arrow-up fs-5 text-success ms-n1"></i>
                                    R$ {(transaction.valor / 100).toFixed(2)}
                                  </div>
                                </span>
                              </td>
                              <td className="text-end pe-0">
                                <span className="text-gray-600 fw-bold fs-6">
                                  {formatDate(transaction.data)}
                                </span>
                              </td>
                              <td className="text-end pe-12">
                                <span className="badge fs-base">
                                  <i className="ki-outline fs-5 ms-n1"></i>
                                  {transaction.couponPercent_off
                                    ? transaction.couponPercent_off
                                    : 0}
                                  %
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4">
                <div className="card card-flush h-xl-100">
                  <div className="card-header pt-5 mb-6">
                    <h3 className="card-title align-items-start flex-column">
                      <div className="d-flex align-items-center mb-2">
                        <span className="fs-3 fw-semibold text-gray-500 align-self-start me-1">
                          $
                        </span>

                        <span className="fs-2hx fw-bold text-gray-800 me-2 lh-1 ls-n2">
                          {(totalSpentOpenAI / 100).toFixed(2)}
                        </span>

                        <span className="badge badge-light-danger fs-base">
                          <i className="ki-outline ki-arrow-down fs-5 text-danger ms-n1"></i>
                          
                        </span>
                      </div>

                      <span className="fs-6 fw-semibold text-gray-500">
                        Créditos da OpenAI
                      </span>
                    </h3>

                    <div className="card-toolbar">
                      <button
                        className="btn btn-icon btn-color-gray-500 btn-active-color-primary justify-content-end"
                        data-kt-menu-trigger="click"
                        data-kt-menu-placement="bottom-end"
                        data-kt-menu-overflow="true"
                      >
                        <i className="ki-outline ki-dots-square fs-1 text-gray-500 me-n1"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body py-0 px-0">
                    <div className="tab-content mt-n6">
                      <div
                        className="tab-pane fade active show"
                        id="kt_charts_widget_33_tab_content_1"
                      >
                        <div
                          id="kt_charts_widget_33_chart_1"
                          data-kt-chart-color="info"
                          className="min-h-auto h-300px ps-3 pe-6"
                        >
                          <ResponsiveContainer width="100%" height={300}>
                            <LineChart
                              data={formattedData}
                              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                            >
                              <CartesianGrid stroke={gridColor} strokeDasharray="none" />
                              <XAxis dataKey="dia" stroke={strokeColor} />
                              <YAxis
                                stroke={strokeColor}
                                padding={{ top: 20, bottom: 20 }}
                                allowDecimals={false}
                              />
                              <Tooltip
                                contentStyle={{
                                  backgroundColor: tooltipBackgroundColor,
                                  border: `1px solid ${tooltipBorderColor}`,
                                }}
                              />
                              <Legend />
                              <Line
                                type="monotone"
                                dataKey="quantidade"
                                stroke={lineColor}
                                activeDot={{ r: 8 }}
                              />
                            </LineChart>
                          </ResponsiveContainer>

                        </div>

                        <div className="table-responsive mx-9 mt-n6">
                          <table className="table align-middle gs-0 gy-4">
                            <thead>
                              <tr>
                                <th className="min-w-50px text-start"></th>
                                <th className="min-w-100px"></th>
                                <th className="min-w-100px text-end pe-0"></th>
                              </tr>
                            </thead>

                            <tbody>

                              {refillsOpenAI.map((refill, index) => (
                              <tr key={index}>
                                <td className="pe-0 text-start">
                                  <span className="fw-bold fs-6">
                                    {refill.codRecarga}
                                  </span>
                                </td>
                                <td>
                                  <p className="text-gray-600 fw-bold fs-6">
                                    {formatDate(refill.dataRecarga)}
                                  </p>
                                </td>
                                <td className="pe-0 text-end">
                                  <span className="fw-bold fs-6 me-1 text-danger">
                                    $ {(refill.valor / 100).toFixed(2)}
                                  </span>
                                </td>
                              </tr>
                            ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-8">
                <div className="card card-flush h-lg-100">
                  <div className="card-header pt-7">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-gray-800">
                        Acessos dos usuários
                      </span>
                      <span className="text-gray-500 mt-1 fw-semibold fs-6">
                        Periodo:
                        1 semana
                      </span>
                      <br />
                      <strong>Total de Acessos:</strong> 
                      <span className="badge badge-light-success fs-base">
                      <i className="ki-outline ki-arrow-up fs-5 text-success ms-n1"></i>
                        {userAccess.length}
                      </span>
                    </h3>

                    <div className="card-toolbar">
                      <div
                        data-kt-daterangepicker="true"
                        data-kt-daterangepicker-opens="left"
                        className="btn btn-sm btn-light d-flex align-items-center px-4"
                        onClick={() => handleClick()}
                      >
                      </div>
                    </div>
                  </div>

                  <div className="card-body pt-6">
                    <div className="table-responsive">
                      <table className="table table-row-dashed align-middle gs-0 gy-3 my-0">
                        <thead>
                          <tr className="fs-7 fw-bold text-gray-500 border-bottom-0">
                            <th className="p-0 pb-3 min-w-175px text-start">
                              CLIENTE
                              <br />
                              <br />
                            </th>
                            <th className="p-0 pb-3 min-w-100px text-end">
                              ENTRADA
                              <br />
                              <br />
                            </th>
                            <th className="p-0 pb-3 min-w-100px text-end">
                              SAIDA
                              <br />
                              <br />
                            </th>
                            <th className="p-0 pb-3 min-w-100px text-end">
                              PERMANENCIA
                              <br />
                              hh:mm:ss
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                              {userAccess.map((access, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="symbol symbol-50px me-3">
                                    {access && access.foto ? (
                                  <img
                                      src={`https://evoktm.com.br/evokchat/fotos_usuarios/${access.foto}`}
                                      alt="Foto do usuário"
                                  />
                              ) : (
                                  <div 
                                      className="symbol-label fs-3 bg-primary text-white" 
                                  >
                                      {access && access.nome ? access.nome.slice(0, 2).toUpperCase() : 'N/A'}
                                  </div>
                              )}
                                  </div>
                                  <div className="d-flex justify-content-start flex-column">
                                    <p
                                      href="apps/projects/users.html"
                                      className="text-gray-800 fw-bold text-hover-primary mb-1 fs-6"
                                    >
                                      {access.nome}
                                    </p>
                                    <span className="text-gray-500 fw-semibold d-block fs-7">
                                      {access.email}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td className="text-end pe-0">
                                <span className="text-gray-600 fw-bold fs-6">
                                  {formatDate(access.dataEntrada)}
                                </span>
                              </td>
                              <td className="text-end pe-0">
                                <span className="text-gray-600 fw-bold fs-6">
                                  {formatDate(access.dataSaida)}
                                </span>
                              </td>
                              <td className="text-end pe-0">
                                <span className="text-gray-600 fw-bold fs-6">
                                  {access.tempoPermanencia}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
